import React from 'react';
import DatePanel from './../core/date';
import OfferSeekTypePanel from './../core/offer-seek-type';
import AttributeListPanel from './../core/attribute-list';
import { NavLink } from 'react-router-dom';
import theme from './../../theme';

const SeekSummaryPanel = ({ seek }) => 
    <section>
        <h2>
            { seek.title }
        </h2>
        <DatePanel label="Posted" date={seek.createdOn} />
        <OfferSeekTypePanel offerSeekType={seek.offerSeekType} />
        <AttributeListPanel attributeList={seek.attributeList} />
        <p>
            { seek.details }
        </p>

        <NavLink 
            style={{ ...theme.getGeneralTextLinkStyle(theme) }} 
            to={`/seek/${seek.id}`}
        >
            More Details
        </NavLink>
        
    </section>
export default SeekSummaryPanel;
